import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@mui/styles';
import { Paper, Box } from '@mui/material';


const useStyles = makeStyles({
  main: {
    padding: 50,
  },
  heading: {
    fontWeight: 'normal',
    textAlign: 'center',
    fontSize: 30,
    color: '#2F5EA8'
  },
  container: {
    padding: '1rem 0.5rem',
    overflow: 'hidden',
  },
  slides: {
    transition: '500ms translate ease-out',
    width: 'max-content',
    display: 'flex',
    gap: '1rem',
  },
  slide: {
    overflow: 'hidden',
    height: 'auto',
    padding: 8,
    flex: 1,
    '& a': { width: '100%' },
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: 100,
    }
  },
});

const links = [
  // 'https://www.youtube.com/watch?v=to324JIljf8',
  // 'http://emerginghimachal.hp.gov.in/',
  // 'https://genpmis.hp.nic.in/',
  // 'http://nmanoc.nic.in/',
  // 'https://www.makeinindia.com/',
  // 'http://himachalforms.nic.in/',
  // 'http://eci.nic.in/eci/nvsp-download.html',
  // 'http://dial.gov.in/',
  // 'http://www.hprera.in/',
  // 'http://india.gov.in/',
  // 'http://himachal.gov.in/',
  // 'https://www.skillindia.gov.in/',
  'https://www.awasbandhu.in/',
  'https://awas.upsdc.gov.in/Home',
  'https://upavp.in/',
  'https://www.coa.gov.in/ver_arch.php?lang=1',
  'https://www.awasbandhu.in/',
  'https://awas.upsdc.gov.in/Home',
  'https://upavp.in/',
  'https://www.coa.gov.in/ver_arch.php?lang=1'
];

const photos = [
  // 'https://i.imgur.com/BVAhezD.png',
  // 'https://i.imgur.com/Fl9PqT1.png',
  // 'https://i.imgur.com/c3lEHJz.png',
  // 'https://i.imgur.com/H6QuzeM.png',
  // 'https://i.imgur.com/NRm2nL0.png',
  // 'https://i.imgur.com/c6cssU2.jpeg',
  // 'https://i.imgur.com/SooSbwF.jpeg',
  // 'https://i.imgur.com/RsvN9Gy.png',
  // 'https://i.imgur.com/M1sPiwn.jpeg',
  // 'https://i.imgur.com/nv2QCPV.jpeg',
  // 'https://i.imgur.com/3iKXNcR.png',
  // 'https://i.imgur.com/v75eNJi.png',
  'https://imgur.com/9IjoR0I.jpeg',
  'https://imgur.com/2n1djI9.png',
  'https://imgur.com/HBlnYIt.png',
  'https://imgur.com/3OhHQd1.png',
  'https://imgur.com/9IjoR0I.jpeg',
  'https://imgur.com/2n1djI9.png',
  'https://imgur.com/HBlnYIt.png',
  'https://imgur.com/3OhHQd1.png'
  
];

const LinksSlideshow = ({titleStyles, containerStyles, noOfSlides = 4}) => {
  const classes = useStyles();
  const galleryRef = useRef(null);
  const slidesRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidePose, setSlidePose] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      const slides = Math.ceil(slidesRef.current?.clientWidth / galleryRef.current?.clientWidth)
      const slideWidth = galleryRef.current?.clientWidth;
      setSlidePose(`-${slideWidth * currentIndex}px 0px`);
      setCurrentIndex((currentIndex + 1) % slides);
    }, 3000);

    return () => clearTimeout(timer);
  }, [currentIndex]);

  return (
    <div className={classes.main} style={{padding:"0.5rem"}}>
      <h2 className={classes.heading} style={titleStyles}>Important Links</h2>
      <Box className={classes.container} style={containerStyles} ref={galleryRef}>
        <Box className={classes.slides} ref={slidesRef} sx={{ translate: slidePose }}>
          {photos.map((photo, i) => (
            <Paper elevation={3} className={classes.slide} key={`${photo}-${i}`} sx={{ width: `${(galleryRef.current?.clientWidth / noOfSlides) - 16}px` }}>
              <a href={links[i]} target='_blank'>
                <img src={photo} alt={`slide-${i}`} />
              </a>
            </Paper>
          ))}
        </Box>
      </Box>
    </div>
  );
};

export default LinksSlideshow;
